import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'wsd-radial-progress',
  templateUrl: './wsd-radial-progress.component.html',
  styleUrls: ['./wsd-radial-progress.component.css']
})
export class WsdRadialProgressComponent implements OnInit {

  @Input()
  progress: number;

  @Input()
  description: string;

  @Input()
  radius: number = 54;

  circumference: number;
  normalizedRadius: number;
  stroke: number = 2;
  percentageY: string = '50%';

  constructor() {
  }

  ngOnInit() {
    this.normalizedRadius = this.radius - this.stroke * 2;
    this.circumference = this.normalizedRadius * 2 * Math.PI;
    if (this.progress !== null) {
      this.progress = Math.ceil(this.progress *= 100);
    }
    if (!this.description) {
      this.percentageY = '55%';
    }
  }

  get strokeDashoffset() {
    return this.circumference - (this.progress || 0) / 100 * this.circumference;
  }
}
